import axios from 'axios';
import bus from './BusEvent';
import { Message } from 'element-ui';
import router from '../router';

function setContentTypeIfUnset (headers, value) {
  headers['Content-Type'] = value
}

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API,
  timeout: 5000,
  withCredentials: true

  //   transformRequest:(data,headers)=>{
  //     if(data){
  //       setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
  //       // let keys2 = Object.keys(data);
  //       // return encodeURI(keys2.map(name => `${name}=${data[name]}`).join('&'));
  //         setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
  //         return JSON.stringify(data);
  //     }
  // }

  // headers:{'Content-Type':'application/json;charset=utf-8'},
  // transformRequest: [function (data,headers) {
  //   // 对 data 进行任意转换处理
  //   setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
  //   return JSON.stringify(data);
  // }],
})

// request拦截器
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // console.log(config)
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.common['accessToken'] = token
    }
    return config
  },
  error => {
    // Do something with request error
    // console.log(error) // for debug
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    const { status, config } = response
    // console.log('status', status)
    if (status === 200) {
      const data = response.data
      // console.log('data', data)
      const msg = response.data.msg
      if (data.code === 1) {
        return response.data
      } else if (data.code === -2 || data.code === -3) {
        // console.log('123')
        router.push({ path: '/login' })
      } else {
        Message.error({
          message: msg
        })
        return Promise.resolve(error);
      }
    }
    if (status === 500) {
      const msg = '网络错误';
    }
    return Promise.reject(new Error('网络错误'))
  },
  error => {
    if ((error + '').indexOf('401') != -1) {
      bus.$emit('toLogin')
    }
    if (error.response.status == 504 || error.response.status == 404) {
      Message.error({
        message: '服务器被吃了⊙﹏⊙∥'
      })
    } else if (error.response.status == 400) {
      Message.error({
        message: '请求出错'
      })
    } else {
      Message.error({
        message: '未知错误!'
      })
    }
    return Promise.resolve(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js